import { cloneElement, createElement, isValidElement } from '@wordpress/element';
import { SVG } from '@wordpress/primitives';
import Dashicon from '../dashicon';

/* The sizing props forwarded to an icon element that is not an `SVG` or a `Dashicon`. */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders a raw icon without any initial styling or wrappers.
 *
 * ```jsx
 * import { wordpress } from '@wordpress/icons';
 *
 * <Icon icon={ wordpress } />
 * ```
 */
function Icon({
  icon = null,
  size = 'string' === typeof icon ? 20 : 24,
  ...additionalProps
}) {
  if ('string' === typeof icon) {
    return /*#__PURE__*/_jsx(Dashicon, {
      icon: icon,
      size: size,
      ...additionalProps
    });
  }
  if (isValidElement(icon) && Dashicon === icon.type) {
    return cloneElement(icon, {
      ...additionalProps
    });
  }
  if ('function' === typeof icon) {
    return createElement(icon, {
      size,
      ...additionalProps
    });
  }
  if (isValidElement(icon)) {
    const {
      style: consumerStyle,
      ...restProps
    } = additionalProps;
    const mergedStyle = icon.props.style || consumerStyle ? {
      ...icon.props.style,
      ...consumerStyle
    } : undefined;
    const styleProps = mergedStyle ? {
      style: mergedStyle
    } : {};
    if (icon.type === 'svg' || icon.type === SVG) {
      const appliedProps = {
        ...icon.props,
        width: size,
        height: size,
        ...restProps,
        // Merge styles so the icon's intrinsic style (e.g. `fill: none` on
        // stroke-based icons) is preserved unless the consumer overrides
        // the same property explicitly.
        ...styleProps
      };
      return /*#__PURE__*/_jsx(SVG, {
        ...appliedProps
      });
    }
    return cloneElement(icon, {
      size,
      width: size,
      height: size,
      ...restProps,
      // Merge styles so the icon's intrinsic style is preserved unless
      // the consumer overrides the same property explicitly.
      ...styleProps
    });
  }
  return icon;
}
export default Icon;